<template>
	<div class="step step2">
		<step-header :current="2"></step-header>
		<el-card class="box-card">
			<div class="radio">
				<el-radio-group v-model="radio">
					<el-radio :label="3">
						<img src="@/assets/images/zhifubao.png">
					</el-radio>
					<el-radio :label="6">
						<img src="@/assets/images/weixinzhifu.png">
					</el-radio>
					<el-radio :label="9">
						<img src="@/assets/images/zaixianzhifu.png">
					</el-radio>
				</el-radio-group>
			</div>
			<div class="btn-wrap">
				<el-button type="primary" size="mini">上一步</el-button>
				<el-button type="primary" size="mini">确认付款</el-button>
			</div>
		</el-card>
	</div>
</template>
<script>
import stepHeader from "./stepHeader";

export default {
	data() {
		return {
			radio: ""
		};
	},
	components: {
		stepHeader
	}
};
</script>
<style lang="scss" scoped>
.step {
	.box-card {
		.radio {
			text-align: center;
			img {
				vertical-align: middle;
			}
			::v-deep.el-radio__inner {
				width: 18px;
				height: 18px;
			}
		}
	}
	.btn-wrap {
		margin-top: 40px;
		text-align: center;
	}
}
@media screen and (max-width: 768px) {
	.step {
		.box-card {
			.radio {
				text-align: left;
				.el-radio {
					width: 100%;
				}
				::v-deep.el-radio__inner {
					width: 18px;
					height: 18px;
				}
			}
		}
	}
}
</style>
